// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__5mZ80","label":"styles_label__JKajc","icon":"styles_icon__2CAPI"};